import Immutable from 'immutable';
import * as docketsConstants from '../../constants/docketsConstants';
import * as irSearchConstants from '../../constants/irSearchConstants';

const initialStateValue = {
  favoriteEmail: {
    status: 'loading',
    email: '',
  },
  popup: {
    name: 'EmailCombinedPdfPopup',
    show: false,
    data: {},
  },
  docketParts: {
    step: 0,
    purchased: 0,
    parts_to_purchase: 0,
    total_cost: 0,
    parts: 0,
    percentage: 0,
    status: 'loading',
    alreadyPurchased: false,
  },
  docketHeader: {
    hasMoreRecentFilingsDate: null,
  },
  // // TODO refactor this client code state into the code from Kirans branch (have to wait for the merge)
  // // https://bitbucket.org/inforuptcy/inforuptcy/pull-requests/1251/moving-client-code-to-react/diff
  // // leaving on dockets reducer for now
  // clientCodeRequired

};

const initialState = Immutable.fromJS(initialStateValue);


const actionHandlers = {
  [docketsConstants.DOCKETS_POPUP]: (state, action) => {
    const { popup } = action;
    return state.mergeDeep({ popup });
  },
  [docketsConstants.DOCKETS_FAVORITE_EMAIL]: (state, action) => {
    const { favoriteEmail } = action;
    return state.mergeDeep({ favoriteEmail });
  },
  [docketsConstants.UPDATE_DOCKETS_PARTS]: (state, action) => {
    const { docketParts } = action;
    return state.mergeDeep({ docketParts });
  },
  [docketsConstants.RESET_DOCKETS_PARTS]: (state) => {
    const { docketParts } = initialStateValue;
    return state.merge({ docketParts });
  },
  [docketsConstants.UPDATE_DOCKET_HEADER]: (state, action) => {
    const { docketHeader } = action;
    return state.merge({ docketHeader });
  },
  [irSearchConstants.REQUEST_DOCKET_PARTS]: (state, action) => {
    const step = action.step || 1;
    const pdfZip = { status: 'loading', step };
    return initialState.mergeDeep({ pdfZip });
  },
  [irSearchConstants.RECEIVE_DOCKET_PARTS]: (state, action) => {
    const pdfZip = { ...action.data, isLoading: false };
    return state.mergeDeep({ pdfZip });
  },
  SERVICE_ERROR: (state, action) => state.mergeDeep({ data_ready: true, error: action.errors }),
};

export default (state = initialState, action) => {
  const actionHandler = actionHandlers[action.type];

  return (actionHandler)
    ? actionHandler(state, action)
    : state;
};



/** WEBPACK FOOTER **
 ** ./src/redux/reducers/docketReducer.js
 **/